import { defaultBillingAccountId } from "@/mock-api/data/billingAccountIds.ts";
import type { Disk } from "@warrenio/api-spec/spec.oats.gen";

const user_id = 136;

export const disksList: Disk[] = [
    {
        uuid: "c5289d43-545e-40a9-a0f4-5f377479cd51",
        user_id,
        billing_account_id: defaultBillingAccountId,
        status: "Active",
        size_gb: 40,
        source_image_type: "OS_BASE",
        source_image: "ubuntu_22.04.01",
        created_at: "2023-09-29T12:17:17.576+0000",
        updated_at: "2024-03-02T16:29:18.900+0000",
        display_name: "",
        snapshots: [
            {
                uuid: "02e6d46d-4d81-41c7-b8a6-09a4ac0f22d9",
                created_at: "2024-03-09T02:00:16.092+0000",
                disk_uuid: "c5289d43-545e-40a9-a0f4-5f377479cd51",
                size_gb: 40,
            },
            {
                uuid: "91c0f608-0b93-4cfb-9994-a90e85365bec",
                created_at: "2024-03-16T02:00:17.929+0000",
                disk_uuid: "c5289d43-545e-40a9-a0f4-5f377479cd51",
                size_gb: 40,
            },
        ],
        storage_pool_uuid: "57a219ef-83fd-412c-8b6a-953ac292bc37",
    },
    {
        uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
        user_id,
        billing_account_id: defaultBillingAccountId,
        status: "Active",
        size_gb: 20,
        source_image_type: "OS_BASE",
        source_image: "service_mariadb_11.4",
        created_at: "2024-03-04T09:33:57.012+0000",
        updated_at: "2024-03-04T09:34:06.677+0000",
        snapshots: [
            {
                uuid: "e5b4e633-2830-4703-9029-48e7154dbe1b",
                created_at: "2024-03-18T01:30:51.685+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
            {
                uuid: "b8decc33-ef6f-4219-bfe2-b326cc3183fd",
                created_at: "2024-03-22T01:30:46.804+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
            {
                uuid: "46daee64-3905-4721-93f9-317749b73efd",
                created_at: "2024-03-17T01:30:54.043+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
            {
                uuid: "e04eaad6-2b1e-4107-a76b-71831d7fe7d9",
                created_at: "2024-03-21T01:30:42.661+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
            {
                uuid: "ab16a4f0-423c-4ede-a17b-f5765b5f940a",
                created_at: "2024-03-20T01:30:48.844+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
            {
                uuid: "999c945c-2085-41d6-801f-1ef4efcd289e",
                created_at: "2024-03-16T01:30:46.834+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
            {
                uuid: "9c425e0b-05a8-40ec-9429-250af0a4bc4f",
                created_at: "2024-03-19T01:30:44.676+0000",
                disk_uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                size_gb: 20,
            },
        ],
        storage_pool_uuid: "57a219ef-83fd-412c-8b6a-953ac292bc37",
    },
];
